{
  "deleteConfirmation": {
    "title": "Potvrdiť vymazanie",
    "description": "Naozaj chcete vymazať túto položku? Túto akciu nie je možné vrátiť späť.",
    "confirm": "Vymazať",
    "cancel": "Zrušiť"
  },
  "confirmation": {
    "title": "Potvrdiť akciu",
    "description": "Naozaj chcete pokračovať?",
    "confirm": "Potvrdiť",
    "cancel": "Zrušiť"
  },
  "error": {
    "generic": "Vyskytla sa chyba. Skúste to znova.",
    "chatDisabled": "Chat je vypnutý pomocou feature flagu."
  },
  "sidebar": {
    "open": "Otvoriť panel",
    "close": "Zavrieť panel"
  },
  "loading": "Načítava sa...",
  "saving": "Ukladá sa...",
  "cancel": "Zrušiť",
  "create": "Vytvoriť",
  "update": "Aktualizovať",
  "today": "Dnes",
  "date": "Dátum",
  "done": "Hotovo",
  "toast": {
    "dismiss": "Zavrieť"
  }
}
